import { render, staticRenderFns } from "./indattindic.vue?vue&type=template&id=7d5d82d5&scoped=true&"
import script from "./indattindic.vue?vue&type=script&lang=js&"
export * from "./indattindic.vue?vue&type=script&lang=js&"
import style0 from "./indattindic.vue?vue&type=style&index=0&id=7d5d82d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5d82d5",
  null
  
)

export default component.exports